import { Divider, Grid, Typography } from "@mui/material";
import React, { memo } from "react";

import { View } from "../../View";
import { makeStyles } from "@mui/styles";
import { palette } from "../../../theme/palette";
import {
  routeSelector,
  driverSelector,
} from "../../../reducers/matrixProfile/selectors";
import { upperCase } from "lodash";
import { useSelector } from "react-redux";

const useStyles = makeStyles({
  container: {
    margin: "5px 0 5px 0",
    display: "flex",
    alignItems: "center",
  },
  routeLabelContainer: {
    flex: "1",
    cursor: "pointer",
  },
  routeLabelBox: {
    backgroundColor: palette.typography.white.high,
    borderRadius: "4px",
    padding: "2px",
    display: "inline-block",
    marginRight: "5px",
    boxShadow: "0px 0px 5px 0px grey",
    marginLeft: "3px",
  },
  routeLabel: {
    pointerEvents: "none",
    width: "26px",
    height: "26px",
    lineHeight: "26px",
    fontSize: "0.75rem",
    textAlign: "center",
    borderRadius: "4px",
    fontWeight: "bold",
    color: "white",
    position: "relative",
  },
  text: {
    fontSize: "13px",
    fontWeight: "bold",
  },
  divider: {
    background: palette.typography.black.neutral,
    margin: "10px 0",
  },
});

export const BaseRouteCodeValueItem = memo(
  ({ routeCode, value, onRouteClick }) => {
    const styles = useStyles();
    const route = useSelector(routeSelector(routeCode));
    const driver = useSelector(driverSelector(route?.driverCode));

    return (
      <View>
        <Grid container justifyContent={"space-between"} alignItems={"center"}>
          <Grid item>
            <View className={styles.routeLabelContainer} onClick={onRouteClick}>
              <View className={styles.routeLabelBox}>
                <View className={styles.routeLabel}>
                  <View
                    style={{
                      background: route?.colour || "black",
                      color: route?.textColour || palette.typography.white.high,
                    }}
                    className={styles.routeLabel}
                  >
                    {routeCode}
                  </View>
                </View>
              </View>
            </View>
          </Grid>
          <Grid item xs={7}>
            <Typography className={styles.text}>
              {upperCase(driver?.driverName)}
            </Typography>
          </Grid>
          <Grid item>
            <Typography className={styles.text}>{value}</Typography>
          </Grid>
        </Grid>
        <Divider className={styles.divider} />
      </View>
    );
  }
);
